import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import { Base64 } from 'js-base64';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import "LIBRARY/Components/ResourceDetails/ImportResource/importResource.css";
import LibraryApiCall from 'LibraryApiCall';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import * as XLSX from "xlsx";

let resourceConditionData = [];
let resourceLanguageData = [];
let resourceTypeData = [];
let locationSubLocationData = [];
let categorySubCategoryData = [];
let multipleSelectOption = [];
let translatedData = [];

class ImportResource extends Component {
    constructor(props) {
        super(props)
        this.tableObject = {};
        this.myRef = React.createRef();
        this.state = {
            importResourceModal: false,
            tabs: [
                { name: "Choose Excel File" },
                { name: "Start Import" }
            ],
            currentTab: 0,

            csvData: [],
            postResourceDetailsArray: [],
            postResourceHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                errors: [],
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
                verificationHistory: {}
            },

            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },
            verifiedData: [],
            selectedCSVFiles: {},

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},
            fullScreen: false,

            errorMessageObjArray: [],
            preRequisiteFileName: 'Prerequisite Data.csv',

            //PreRequisite data
            preRequisiteCSVDataForFaculty: [
                { location: '', category: '', department: '', accessionSeries: '', resourceLanguage: '', publisher: '', translated: '', resourceCondition: '', resourceType: '', invoice: '' },
            ],

            preRequisiteData: [],
            GetStreamList: {},
            loadingStreamData: false,
            loadingYearData: false,
            loadingCategoryData: false,
            loadingAgengyData: false,
            loadingAgengyMOUData: false,
            academicYearList: {},
            academicYearSequence: [],
            dropDownstreamList: [],
            preRequisiteCSVHeadersForFaculty: [
                { label: "Location", key: "location" },
                { label: "Resource Category", key: "category" },
                { label: "Department ", key: "department" },
                { label: "Accession Series ", key: "accessionSeries" },
                { label: "Resource Language", key: "resourceLanguage" },
                { label: "Publisher", key: "publisher" },
                { label: "Translated", key: "translated" },
                { label: "Resource Condition", key: "resourceCondition" },
                { label: "Resource Type", key: "resourceType" },
                { label: "Invoice", key: "invoice" },
            ],

            categoryList: {},
            preRequisiteHeaders: [],
            loadingImportResourceProcess: false,

            GetPublisherList: {},
            loadingPublisherData: false,
            searchPublisher: '',
            publisherPageIndex: 'all',
            publisherLimit: 'all',

            isImportButtonDisabled: false,
            iidPreRequisiteData: config.institute_id,
            iidImportResource: config.institute_id,

            GetLocationList: {},
            loadingLocationData: false,

            GetResourceCategoryList: {},
            loadingResourceCategoryData: false,

            GetDepartmentList: {},
            loadingDepartmentData: false,

            accessionSeriesList: {},
            loadingAccessionSeriesData: false,

            publisherDataList: {},
            loadingPublisherDetails: false,

            GetInvoiceDataList: {},
            loadingInvoiceData: false,

            // import resource data state
            ImportGetLocationList: {},
            loadingImportLocationData: false,

            ImportGetResourceCategoryList: {},
            loadingImportResourceCategoryData: false,

            ImportGetDepartmentList: {},
            loadingImportDepartmentData: false,

            ImportaccessionSeriesList: {},
            loadingImportAccessionSeriesData: false,

            ImportpublisherDataList: {},
            loadingImportPublisherDetails: false,

            ImportGetInvoiceDataList: {},
            loadingImportInvoiceData: false,
        }
    }

    componentDidMount() {
        this.setState({
            importResourceModal: this.props.isShowImportResourceButton,
            isImportButtonDisabled: false,
        })

        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty
        let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForFaculty

        // API Call for pre-requisite data
        this.GetLibraryLocationList();  // location list
        this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
        this.apiCallToGetInstituteStreamList();  // department
        this.apiCallToGetAccessionSeries(); // accession series
        this.getPublisherList();  // publisher list
        this.getLibraryInvoiceListDataStatus();  // invoice data  

        // API Call for import resource data
        this.ImportGetLibraryLocationList();  // location list
        this.ImportGetLibraryResourceCategoryListWithBasicDetails();  // resource category
        this.ImportapiCallToGetInstituteStreamList();  // department
        this.ImportapiCallToGetAccessionSeries(); // accession series
        this.ImportgetPublisherList();  // publisher list
        this.ImportgetLibraryInvoiceListDataStatus();  // invoice data  

        resourceConditionData = ["Good", "Partially damaged", "Completely Damaged"]
        resourceLanguageData = ["English", "Marathi", "Assamese", "Bengali", "Gujarati", "Kannada", "Kashmiri", "Konkani", "Malayalam", "Manipuri", "Oriya", "Punjabi", "Hindi", "Sanskrit", "Sindhi", "Tamil", "Telugu", "Urdu"]
        resourceTypeData = [
            "Text Book",
            "Reference Book",
            "Atlas",
            "Biography",
            "Book with CD",
            "CD-ROM",
            "Floppy",
            "General",
            "Laboratory Manual",
            "Practical",
            "Practical Manual",
            " Practical Note Book",
            "Text Book(Practical)",
            "Text Book(Theory & Practical)",
            "Question Bank",
            "Project Thesis",
            "Other",
            "Book bank",
            "Bound Volume",
            "Current issue of the journals",
            "Syllabus copy",
            "Previous years question papers copy"
        ]
        translatedData = ["Yes", "No"]

        // for resource condition data
        if (resourceConditionData.length > 0) {
            resourceConditionData.map((data, index) => {
                if (data != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].resourceCondition = data
                    } else {
                        preRequisiteData.push({ location: '', category: '', department: '', accessionSeries: '', resourceLanguage: '', publisher: '', translated: '', resourceCondition: data, resourceType: '', invoice: '' })
                    }
                }
            })
        }

        // for resource language data
        if (resourceLanguageData.length > 0) {
            resourceLanguageData.map((data, index) => {
                if (data != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].resourceLanguage = data
                    } else {
                        preRequisiteData.push({ location: '', category: '', department: '', accessionSeries: '', resourceLanguage: data, publisher: '', translated: '', resourceCondition: '', resourceType: '', invoice: '' })
                    }
                }
            })
        }

        // for resource type data
        if (resourceTypeData.length > 0) {
            resourceTypeData.map((data, index) => {
                if (data != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].resourceType = data
                    } else {
                        preRequisiteData.push({ location: '', category: '', department: '', accessionSeries: '', resourceLanguage: '', publisher: '', translated: '', resourceCondition: '', resourceType: data, invoice: '' })
                    }
                }
            })
        }

        // for resource condition data
        if (translatedData.length > 0) {
            translatedData.map((data, index) => {
                if (data != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].translated = data
                    } else {
                        preRequisiteData.push({ location: '', category: '', department: '', accessionSeries: '', resourceLanguage: '', publisher: '', translated: data, resourceCondition: '', resourceType: '', invoice: '' })
                    }
                }
            })
        }

        this.setState({
            preRequisiteData: preRequisiteData,
            preRequisiteHeaders: preRequisiteHeaders,
        })
    }

    // API Call For Pre-Requisite START

    // API CALL TO GET get location List 
    GetLibraryLocationList = async () => {
        this.setState({
            loadingLocationData: true,
        })

        let requestData = {
            iid: this.state.iidPreRequisiteData
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryLocationList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryLocationList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const sublocations = [];

                    // If there are sublocations, iterate through them
                    if (seriesData.subLocationCount > 0) {
                        Object.entries(seriesData.sublocation).forEach(([sublocationId, sublocationData]) => {
                            sublocations.push({
                                sublocationId: sublocationId,
                                sublocationName: sublocationData.name
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        sublocations: sublocations // Add sublocation data (if any)
                    };
                });

                this.setState({
                    GetLocationList: formattedData,
                    loadingLocationData: false,
                })
            } else {
                this.setState({
                    loadingLocationData: false,
                })
            }
        }
    }

    // API CALL TO GET get resource category List 
    GetLibraryResourceCategoryListWithBasicDetails = async () => {
        this.setState({
            loadingResourceCategoryData: true,
        })

        let requestData = {
            iid: this.state.iidPreRequisiteData,
            isSortByAscendingCategoryName: "true"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceCategoryListWithBasicDetails',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceCategoryListWithBasicDetails();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const subCategories = [];

                    // If there are subCategories, iterate through them
                    if (Object.values(seriesData.subresource).length > 0) {
                        Object.entries(seriesData.subresource).forEach(([subCategoryId, subCategoryData]) => {
                            subCategories.push({
                                subCategoryId: subCategoryId,
                                subCategoryName: subCategoryData.name,
                                parentId: subCategoryData.parentCategoryId
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        subCategories: subCategories // Add subresource data (if any)
                    };
                });


                this.setState({
                    GetResourceCategoryList: formattedData,
                    loadingResourceCategoryData: false,
                })
            } else {
                this.setState({
                    loadingResourceCategoryData: false,
                })
            }
        }
    }

    // API CALL TO GET get Institute Stream List 
    apiCallToGetInstituteStreamList = async () => {
        this.setState({
            loadingStreamData: true,
        })

        let requestData = {
            "iid": this.state.iidPreRequisiteData,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                let formattedData = Object.entries(apiResult).map(([sid, details]) => ({
                    sid,
                    name: details.stream_name
                }));

                this.setState({
                    GetStreamList: formattedData,
                    loadingStreamData: false,
                })
            } else {
                this.setState({
                    loadingStreamData: false,
                })
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    apiCallToGetAccessionSeries = async () => {
        this.setState({ loadingAccessionSeriesData: true });

        let requestData = {
            "iid": this.state.iidPreRequisiteData,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                // if (Object.keys(apiResult).length > 0) {
                //     Object.keys(apiResult).map(seriesId => {
                //         apiResult[seriesId]['seriesId'] = seriesId;
                //     });
                // }

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    accessionSeriesList: formattedMembers,
                    loadingAccessionSeriesData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingAccessionSeriesData: false
                });
            }
        }
    }

    // API CALL TO GET get publisher List 
    getPublisherList = async () => {
        this.setState({
            loadingPublisherDetails: true,
        })

        let requestData = {
            iid: this.state.iidPreRequisiteData,
            isOrderByAscendingDisplayName: "true",
            pageIndex: "all",
            limitPerPage: "all"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPublisherList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPublisherList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    name: seriesData?.name,
                }));

                this.setState({
                    publisherDataList: formattedData,
                    loadingPublisherDetails: false,
                })
            } else {
                this.setState({
                    loadingPublisherDetails: false,
                })
            }
        }
    }

    // API CALL TO GET get invoice List 
    getLibraryInvoiceListDataStatus = async () => {
        this.setState({
            loadingInvoiceData: true,
        })

        let requestData = {
            iid: this.state.iidPreRequisiteData,
            pageIndex: "all",
            limitPerPage: "all",
            linkedTo: "library"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getTransactionListBasedOnLinkedTo',
            requestData,
            "/api/instructor/accountingManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getLibraryInvoiceListDataStatus();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    billno: seriesData?.billno, // Display billno
                    vendorName: seriesData?.vendorName,
                    billdate: seriesData?.billdate,
                    vendorId: seriesData?.vendor,
                    uniqueId: seriesId
                }));

                this.setState({
                    GetInvoiceDataList: formattedData,
                    loadingInvoiceData: false,
                })
            } else {
                this.setState({
                    loadingInvoiceData: false,
                })
            }
        }
    }

    // API Call Pre-Requisite END

    // API Call Import START

    // API CALL TO GET get location List 
    ImportGetLibraryLocationList = async () => {
        this.setState({
            loadingLocationData: true,
        })

        let requestData = {
            iid: this.state.iidImportResource
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryLocationList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryLocationList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const sublocations = [];

                    // If there are sublocations, iterate through them
                    if (seriesData.subLocationCount > 0) {
                        Object.entries(seriesData.sublocation).forEach(([sublocationId, sublocationData]) => {
                            sublocations.push({
                                sublocationId: sublocationId,
                                sublocationName: sublocationData.name
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        sublocations: sublocations // Add sublocation data (if any)
                    };
                });

                this.setState({
                    GetLocationList: formattedData,
                    loadingLocationData: false,
                })
            } else {
                this.setState({
                    loadingLocationData: false,
                })
            }
        }
    }

    // API CALL TO GET get resource category List 
    ImportGetLibraryResourceCategoryListWithBasicDetails = async () => {
        this.setState({
            loadingResourceCategoryData: true,
        })

        let requestData = {
            iid: this.state.iidImportResource,
            isSortByAscendingCategoryName: "true"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceCategoryListWithBasicDetails',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceCategoryListWithBasicDetails();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const subCategories = [];

                    // If there are subCategories, iterate through them
                    if (Object.values(seriesData.subresource).length > 0) {
                        Object.entries(seriesData.subresource).forEach(([subCategoryId, subCategoryData]) => {
                            subCategories.push({
                                subCategoryId: subCategoryId,
                                subCategoryName: subCategoryData.name,
                                parentId: subCategoryData.parentCategoryId
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        subCategories: subCategories // Add subresource data (if any)
                    };
                });


                this.setState({
                    GetResourceCategoryList: formattedData,
                    loadingResourceCategoryData: false,
                })
            } else {
                this.setState({
                    loadingResourceCategoryData: false,
                })
            }
        }
    }

    // API CALL TO GET get Institute Stream List 
    ImportapiCallToGetInstituteStreamList = async () => {
        this.setState({
            loadingStreamData: true,
        })

        let requestData = {
            "iid": this.state.iidImportResource,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                let formattedData = Object.entries(apiResult).map(([sid, details]) => ({
                    sid,
                    name: details.stream_name
                }));

                this.setState({
                    GetStreamList: formattedData,
                    loadingStreamData: false,
                })
            } else {
                this.setState({
                    loadingStreamData: false,
                })
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    ImportapiCallToGetAccessionSeries = async () => {
        this.setState({ loadingAccessionSeriesData: true });

        let requestData = {
            "iid": this.state.iidImportResource,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                // if (Object.keys(apiResult).length > 0) {
                //     Object.keys(apiResult).map(seriesId => {
                //         apiResult[seriesId]['seriesId'] = seriesId;
                //     });
                // }

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    accessionSeriesList: formattedMembers,
                    loadingAccessionSeriesData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingAccessionSeriesData: false
                });
            }
        }
    }

    // API CALL TO GET get publisher List 
    ImportgetPublisherList = async () => {
        this.setState({
            loadingPublisherDetails: true,
        })

        let requestData = {
            iid: this.state.iidImportResource,
            isOrderByAscendingDisplayName: "true",
            pageIndex: "all",
            limitPerPage: "all"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPublisherList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPublisherList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    name: seriesData?.name,
                }));

                this.setState({
                    publisherDataList: formattedData,
                    loadingPublisherDetails: false,
                })
            } else {
                this.setState({
                    loadingPublisherDetails: false,
                })
            }
        }
    }

    // API CALL TO GET get invoice List 
    ImportgetLibraryInvoiceListDataStatus = async () => {
        this.setState({
            loadingInvoiceData: true,
        })

        let requestData = {
            iid: this.state.iidImportResource,
            pageIndex: "all",
            limitPerPage: "all",
            linkedTo: "library"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getTransactionListBasedOnLinkedTo',
            requestData,
            "/api/instructor/accountingManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getLibraryInvoiceListDataStatus();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    billno: seriesData?.billno, // Display billno
                    vendorName: seriesData?.vendorName,
                    billdate: seriesData?.billdate,
                    vendorId: seriesData?.vendor,
                    uniqueId: seriesId
                }));

                this.setState({
                    GetInvoiceDataList: formattedData,
                    loadingInvoiceData: false,
                })
            } else {
                this.setState({
                    loadingInvoiceData: false,
                })
            }
        }
    }

    // API Call Import END

    closeImportResourceModal = () => {
        this.setState({
            importResourceModal: false,
            currentTab: 0,

            csvData: [],
            postResourceDetailsArray: [],
            postResourceHeadersArray: [],
            selectedCSVFiles: {},
            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            verifiedData: [],
            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },
            verifiedData: [],
            selectedCSVFiles: {},

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},

        });
        // document.getElementById("react-csv-reader-input").value = '';
        // Clear the file input field using document.getElementById
        // const fileInput = document.getElementById("react-csv-reader-input");
        const fileInput = document.getElementById("react-excel-reader-input-resource");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        };

        this.props.closeImportModalForResources();
    }

    // OPEN FILE
    openFileInput = () => {
        // document.getElementById("react-csv-reader-input").click();
        document.getElementById("react-excel-reader-input-resource").click();
    }

    // REMOVE SELECTED CSV FILE
    removeCSVFile = () => {
        this.setState({
            selectedCSVFiles: {},
            csvData: [],
            postResourceDetailsArray: [],
            postResourceHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            selectedCSVFiles: {},
            verifiedData: [],
        });
        // document.getElementById("react-csv-reader-input").value = '';
        // Clear the file input field using document.getElementById
        // const fileInput = document.getElementById("react-csv-reader-input");
        const fileInput = document.getElementById("react-excel-reader-input-resource");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        }
    }

    // Import Resource Modal
    importResourceModal = () => {
        let resultFailedData = this.state.postResourceDetailsArray.filter((item) => item.importStatus == 'failed')
        let resultSuccessData = this.state.postResourceDetailsArray.filter((item) => item.importStatus == 'success')
        let resultPendingData = this.state.postResourceDetailsArray.filter((item) => item.importStatus == 'pending')

        return (
            <>
                <div className={this.state.importResourceModal ? 'modal fade show' : 'modal'} style={{ display: this.state.importResourceModal ? "block" : 'none', visibility: this.state.importResourceModal ? 'visible' : 'hidden' }}>
                    <div class="modal-dialog modal-lg--userdetails modal-dialog-centered" style={{ maxWidth: this.state.fullScreen ? '100vw' : '60vw', margin: this.state.fullScreen ? "0px auto" : "auto" }}>
                        <div class="modal-content modal-dialog-scrollable modal_content">
                            <div class="modal-header modal_header">
                                <h5 class="modal-title" style={{ textAlign: 'left' }} id="exampleModalLabel">Import Resource Details</h5>
                                {this.state.loadingImportResourceProcess || this.state.loadingImportProcess ?
                                    null :
                                    <>
                                        <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
                                            <button style={{ all: 'unset', cursor: "pointer" }} onClick={() => {
                                                this.setState({
                                                    fullScreen: !this.state.fullScreen
                                                })
                                            }}>
                                                {
                                                    this.state.fullScreen ?
                                                        (
                                                            <span>
                                                                <span style={{ border: '2px solid #000 !important', padding: '2px' }} title={"Compress Edit Mode"}><FontAwesomeIcon icon={['fas', 'compress-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                            </span>
                                                        ) :
                                                        (
                                                            <span>
                                                                <span style={{ border: '2px solid #000 !important', padding: '2px' }} title={"Expand Edit Mode"}><FontAwesomeIcon icon={['fas', 'expand-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                            </span>
                                                        )
                                                }
                                            </button>
                                            <span style={{ cursor: "pointer" }} onClick={() => {
                                                this.closeImportResourceModal()
                                            }}>
                                                <FontAwesomeIcon icon={['fas', 'times']} size={'md'} />
                                            </span>
                                        </div>
                                    </>
                                }
                            </div>
                            <div class="modal-body" style={{ maxHeight: this.state.fullScreen ? '100vh' : "80vh", height: this.state.fullScreen ? '100vh' : '80vh' }}>
                                <div className="">
                                    <div className="row">
                                        <div className="col">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="import-header">
                                                    {
                                                        this.state.tabs.map((item, index) => {
                                                            return (
                                                                <div className="tab-wrapper"><span className={this.state.currentTab == index ? "circle-tab" : "circle-tab-muted"}>{index + 1}</span><p className={this.state.currentTab == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p></div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                {/* <button style={{ all: 'unset', cursor: "pointer" }} onClick={() => {
                                                    this.setState({
                                                        fullScreen: !this.state.fullScreen
                                                    })
                                                }}>
                                                    {
                                                        this.state.fullScreen ?
                                                            (
                                                                <span>
                                                                    <span style={{ border: '2px solid #000', padding: '2px' }} title={"Compress Edit Mode"}><FontAwesomeIcon icon={['fas', 'compress-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                                </span>
                                                            ) :
                                                            (
                                                                <span>
                                                                    <span style={{ border: '2px solid #000', padding: '2px' }} title={"Expand Edit Mode"}><FontAwesomeIcon icon={['fas', 'expand-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                                </span>
                                                            )
                                                    }
                                                </button> */}
                                            </div>

                                            {
                                                this.state.currentTab == 0 && this.chooseFileComponent()
                                            }
                                            {
                                                this.state.currentTab == 1 && this.importCSVFileComponent()
                                            }

                                            <div className="import-footer">
                                                {
                                                    this.state.currentTab == 1 &&

                                                    <div style={{ width: '100%', margin: '0px 10px 0 0' }}>

                                                        {
                                                            <div className="d-flex align-items-center flex-wrap" style={{ display: this.state.loadingImportProcess ? '' : 'none !important' }}>
                                                                {
                                                                    <>
                                                                        <ProgressBar bgcolor={"#6a1b9a"} completed={this.state.importProgressSummary['completed']} failed={this.state.importProgressSummary['failed']} total={this.state.importProgressSummary['total']} pending={this.state.importProgressSummary['pending']} />
                                                                        <p className="mb-0 font-weight-bold" style={{ fontSize: 14 }}>Import Progress: {(this.state.importProgressSummary['total'] - this.state.importProgressSummary['pending'])} | {this.state.importProgressSummary['total']}</p>
                                                                    </>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    this.state.currentTab == 0 && this.state.csvData.length > 0 && this.state.validations['isHeadersValid'] && (
                                                        <button type="button" className="btn import-btn" onClick={() => {
                                                            this.setState({
                                                                currentTab: 1
                                                            })
                                                        }}>
                                                            Proceed
                                                        </button>
                                                    )
                                                }
                                                {
                                                    this.state.currentTab == 1 && (
                                                        <>
                                                            {
                                                                this.state.validations['isVerified'] ?
                                                                    <span className="d-flex align-items-center text-success-color font-size14 font-weight-bold">
                                                                        <FontAwesomeIcon icon={['fas', 'check-circle']} size={'md'} className="mx-1"></FontAwesomeIcon> Verified
                                                                    </span>
                                                                    :
                                                                    resultPendingData?.length > 0 || resultFailedData?.length > 0 ?
                                                                        this.state.loadingImportProcess ? <ButtonLoader /> :
                                                                            <button type="button" className="btn import-btn" disabled={this.state.validations['isVerified']}
                                                                                onClick={() => {

                                                                                    let importProgressSummary = { completed: 0, failed: 0, total: this.state.postResourceDetailsArray.length, pending: this.state.postResourceDetailsArray.length }
                                                                                    this.setState({
                                                                                        loadingImportProcess: true,
                                                                                        importProgressSummary
                                                                                    }, () => {
                                                                                        this.apiCallToImportVerifyResourceDetails(0, this.state.importProgressSummary)
                                                                                    })
                                                                                }

                                                                                }
                                                                            >
                                                                                Verify
                                                                            </button>

                                                                        : null
                                                            }

                                                            {/* (resultSuccessData?.length > 0 && (resultFailedData?.length == 0 || this.state.loadingImportProcess == false)) */}
                                                            {(resultSuccessData?.length > 0 && this.state.loadingImportProcess == false && resultFailedData?.length == 0) ?
                                                                this.state.loadingImportResourceProcess ? <ButtonLoader /> :
                                                                    < button type="button" className="btn import-btn" disabled={this.state.isImportButtonDisabled} onClick={() => {
                                                                        this.setState({
                                                                            loadingImportResourceProcess: true
                                                                        }, () => {
                                                                            this.apiCallToImportResourceDetails(0)
                                                                        })
                                                                    }
                                                                    }>
                                                                        Import
                                                                    </button>
                                                                : null
                                                            }

                                                            {/* {
                                                                this.checkImportStatus() ?
                                                                    <span className="d-flex align-items-center text-success-color font-size14 font-weight-bold">
                                                                        <FontAwesomeIcon icon={['fas', 'check-circle']} size={'md'} className="mx-1"></FontAwesomeIcon> Imported Successfully
                                                                    </span>
                                                                    :
                                                                    <>
                                                                        <button type="button" className="btn import-btn" onClick={() => {

                                                                            let importProgressSummary = { completed: 0, failed: 0, total: this.state.postResourceDetailsArray.length, pending: this.state.postResourceDetailsArray.length }
                                                                            this.setState({
                                                                                loadingImportProcess: true,
                                                                                importProgressSummary
                                                                            }, () => {

                                                                                this.apiCallToImportResourceDetails(0, this.state.importProgressSummary)
                                                                            })
                                                                        }

                                                                        }>
                                                                            Import
                                                                        </button>
                                                                    </>
                                                            } */}
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.importResourceModal && <div className="modal-backdrop fade show"></div>}
            </>
        )
    }

    // export subscription details into excel format
    exportData = () => {
        // Define the CSV headers
        const headers = [
            "Accession Series*", "Accession Number*", "Accession Date", "Call Number", "Title*", "Author Name*", "Resource Volume", "Resource Edition", "Resource Language*", "Publisher*", "Number of Pages", "Number of Preliminary Pages", "Resource Category*", "Year of Publication", "Department", "Resource Type*", "Translator Name", "Translated", "Search Keyword", "Resource Medium", "Location", "ISBN Number", "Resource Condition", "Invoice/Bill No", "Invoice/ Bill Date", "Price (In Rs)", "Discount (In %)", "Net Price (In Rs)"
        ];

        // Adding sample hard-coded data
        const sampleData = [
            [
                "ACCSR1", "1", "2022-07-13", "CD:56:TPY", "The Power of your Subconscious Mind", "Dr. Murphy Joseph", "1", "1", "English", "Amazing Reads", "312", "5", "Self-Help Book", "2018", "Art", "General", "", "No", "", "Physical", "Shelf 2.4", "9788192910963", "Good", "67", "2018-07-13", "140", "0", "140"
            ],
            [
                "ACCSR2", "2", "2020-07-13", "CD:56:GVG", "Good Vibes Good Life", "Vex King", "1", "1", "English", "Hay House UK Ltd", "304", "5", "Self-Help Book", "2020", "Art", "General", "", "No", "", "Physical", "Shelf 5.4", "9781788171823", "Good", "123", "2020-07-13", "195", "0", "195"
            ]
        ];

        const fileName = 'Resources Details.xlsx';
        const rowData = [];

        // Loop through the resource data and generate rows for the table
        sampleData.map(data => {
            const row = [
                data[0] || '',  // Title
                data[1] || '',  // Vendor
                data[2] || '',  // Start Date
                data[3] || '',  // End Date
                data[4] || '',  // Number Of Expected Issues
                data[5] || '',  // Average Price Per Copy
                data[6] || '',
                data[7] || '',
                data[8] || '',
                data[9] || '',
                data[10] || '',
                data[11] || '',
                data[12] || '',
                data[13] || '',
                data[14] || '',
                data[15] || '',
                data[16] || '',
                data[17] || '',
                data[18] || '',
                data[19] || '',
                data[20] || '',
                data[21] || '',
                data[22] || '',
                data[23] || '',
                data[24] || '',
                data[25] || '',
                data[26] || '',
                data[27] || ''
            ];


            // Add the row to the data
            rowData.push(row);
        });

        // Create the worksheet with headers and data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rowData]);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Write the file (download the .xlsx file)
        XLSX.writeFile(workbook, fileName);

    };

    // download pre-requisite data in excel format
    exportPreRequisiteData = () => {
        // Define the CSV headers
        const headers = this.state.preRequisiteCSVHeadersForFaculty.map(header => header.label);
        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty

        const fileName = 'PreRequisite_Resources_Details.xlsx';
        const rowData = [];

        // For Location
        // custom location and sub-location data list
        locationSubLocationData = Object.values(this.state.GetLocationList).flatMap(item => [
            { value: item.value, name: item.name },
            ...item?.sublocations.map(sublocation => ({
                value: sublocation.sublocationId,
                name: sublocation.sublocationName
            }))
        ]);

        // For location Data
        if (locationSubLocationData?.length > 0) {
            locationSubLocationData?.map((data, index) => {
                if (data?.name != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].location = data?.name
                    } else {

                        preRequisiteData.push({ location: data?.name, category: '', department: '', accessionSeries: '', resourceLanguage: '', publisher: '', translated: '', resourceCondition: '', resourceType: '', invoice: '' })
                    }
                }
            })
        }

        // For Resource Category
        // custom category and sub-category data list
        categorySubCategoryData = Object.values(this.state.GetResourceCategoryList).flatMap(item => [
            { value: item.value, name: item.name },
            ...item?.subCategories.map(subCategory => ({
                value: subCategory.subCategoryId,
                name: subCategory.subCategoryName,
                parentId: subCategory.parentId
            }))
        ]);

        // for resource category data
        if (categorySubCategoryData.length > 0) {
            categorySubCategoryData.map((data, index) => {
                if (data?.name != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].category = data?.name
                    } else {
                        preRequisiteData.push({ location: '', category: data?.name, department: '', accessionSeries: '', resourceLanguage: '', publisher: '', translated: '', resourceCondition: '', resourceType: '', invoice: '' })
                    }
                }
            })
        }

        // For department (stream data)
        if (Object.values(this.state.GetStreamList).length > 0) {
            Object.values(this.state.GetStreamList).map((data, index) => {
                if (data?.name != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].department = data?.name
                    } else {
                        preRequisiteData.push({ location: '', category: '', department: data?.name, accessionSeries: '', resourceLanguage: '', publisher: '', translated: '', resourceCondition: '', resourceType: '', invoice: '' })
                    }
                }
            })
        }

        // For accession Series Data
        if (Object.values(this.state.accessionSeriesList).length > 0) {
            Object.values(this.state.accessionSeriesList).map((data, index) => {
                if (data?.label != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].accessionSeries = data?.label
                    } else {
                        preRequisiteData.push({ location: '', category: '', department: '', accessionSeries: data?.label, resourceLanguage: '', publisher: '', translated: '', resourceCondition: '', resourceType: '', invoice: '' })
                    }
                }
            })
        }

        // for publisher data
        if (Object.values(this.state.publisherDataList).length > 0) {
            Object.values(this.state.publisherDataList).map((data, index) => {
                if (data?.name != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].publisher = data?.name
                    } else {
                        preRequisiteData.push({ location: '', category: '', department: '', accessionSeries: '', resourceLanguage: '', publisher: data?.name, translated: '', resourceCondition: '', resourceType: '', invoice: '' })
                    }
                }
            })
        }

        // for invoice data
        if (Object.values(this.state.GetInvoiceDataList).length > 0) {
            Object.values(this.state.GetInvoiceDataList).map((data, index) => {
                if ((data?.vendorName || data?.billno) != undefined) {
                    const invoiceValue = `${data?.vendorName || ''} | ${data?.billno || ''}`;
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].invoice = invoiceValue
                    } else {
                        preRequisiteData.push({ location: '', category: '', department: '', accessionSeries: '', resourceLanguage: '', publisher: '', translated: '', resourceCondition: '', resourceType: '', invoice: invoiceValue })
                    }
                }
            })
        }

        // // For Department
        // if (Object.values(this.state.GetStreamList).length > 0) {
        //     Object.keys(this.state.GetStreamList).map((stream, index) => {
        //         let branch = this.state.GetStreamList[stream]
        //         if (branch != undefined) {
        //             if (preRequisiteData[index] != undefined) {
        //                 preRequisiteData[index].branch = branch.name
        //             } else {
        //                 preRequisiteData.push({ periodicity: '', category: '', department: branch.name })
        //             }
        //         }
        //     })
        // }

        // // For categoryList
        // if (Object.values(this.state.categoryList).length > 0) {
        //     Object.keys(this.state.categoryList).map((Id, index) => {
        //         let category = this.state.categoryList[Id]
        //         if (category != undefined) {
        //             if (preRequisiteData[index] != undefined) {
        //                 preRequisiteData[index].category = category.category_name
        //             } else {
        //                 preRequisiteData.push({ periodicity: '', category: category.category_name, department: '' })
        //             }
        //         }
        //     })
        // }


        // Loop through the resource data and generate rows for the table
        preRequisiteData.forEach(resource => {
            const row = this.state.preRequisiteCSVHeadersForFaculty.map(header => {
                // Access each key dynamically from resource using the header key
                return resource[header.key] || ''; // If no value exists, return an empty string
            });

            // Add the row to the data
            rowData.push(row);
        });

        // Create the worksheet with headers and data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rowData]);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Write the file (download the .xlsx file)
        XLSX.writeFile(workbook, fileName);
    };

    // display excel data onchange of choose file
    handleExcelInput = (event) => {
        const file = event.target.files[0];

        const fileDetails = {
            name: file.name,
            lastModified: file.lastModified,
            lastModifiedDate: file.lastModifiedDate,
            webkitRelativePath: file.webkitRelativePath,
            size: file.size,
            type: file.type
        };


        this.setState({
            selectedCSVFiles: fileDetails
        })

        if (!file) {
            this.setState({
                successModalType: "error",
                successMessage: "No file selected.",
                isValidAttachment: false,
                successModal: true,
            });
            return;
        }

        if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
            file.type !== "application/vnd.ms-excel") {
            this.setState({
                selectedCSVFiles: {},
                successModalType: "error",
                successMessage: "Please select a valid Excel file.",
                isValidAttachment: false,
                successModal: true,
            })
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const binaryData = e.target.result;
            const workbook = XLSX.read(binaryData, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

            this.processExcelData(sheetData);
        };

        reader.readAsBinaryString(file);
    }

    processExcelData = (sheetData) => {
        if (sheetData.length === 0) {
            this.setState({
                successModalType: "error",
                successMessage: "Excel file is empty.",
                isValidAttachment: false,
            });
            return;
        }

        const headers = sheetData[0];
        const rows = sheetData.slice(0);

        let postResourceDetailsArray = [];
        let postResourceHeadersArray = [];
        // let validations = this.state.validations;
        // let headersArrayObject = this.state.preRequisiteCSVHeadersForStudentMarks;

        // // Validate headers
        if (headers != undefined && headers.length > 0) {
            headers.map((headerName, index) => {
                if (headerName != undefined && headerName.trim() !== "") {
                    postResourceHeadersArray.push(headerName.trim());
                }
            })
        } else {
            toast.warn("Invalid headers found in imported excel file.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }

        // Find the index of the column
        const accessionDateIndex = postResourceHeadersArray.indexOf("Accession Date");
        const invoiceDateIndex = postResourceHeadersArray.indexOf("Invoice/ Bill Date");

        // Read Excel Actual Body Data including date
        if (postResourceHeadersArray.length > 0) {
            rows.map((csvRow, index) => {
                if (index !== 0) {
                    let resourceObject = {};

                    for (let i = 0; i < postResourceHeadersArray.length; i++) {
                        let value = csvRow[i];

                        // Format the "Accession Date" if it exists and is a valid date
                        if (i === accessionDateIndex && value) {
                            let formattedDate = this.formatDate(value);  // Format the date
                            value = formattedDate;  // Assign the formatted date
                        }

                        // Format the "Invoice/ Bill Date" if it exists and is a valid date
                        if (i === invoiceDateIndex && value) {
                            let formattedDate = this.formatDate(value);  // Format the date
                            value = formattedDate;  // Assign the formatted date
                        }

                        // Add the value to the resource object
                        resourceObject[postResourceHeadersArray[i]] = value === undefined || value === null ? "" : value;
                    }

                    // Add the updated resource object to the final array
                    postResourceDetailsArray.push({
                        ...resourceObject,
                        verificationStatus: "pending",
                        importStatus: "pending",
                        loading: false
                    });
                }
            });
        }

        this.setState({
            csvData: [...rows],
            postResourceDetailsArray: postResourceDetailsArray,
            postResourceHeadersArray: postResourceHeadersArray
        }, () => {
            this.validateCSVFileHeaders();

        })
    };

    formatDate = (dateValue) => {
        // If the value is a number (Excel timestamp), convert it to a JavaScript date
        if (typeof dateValue === 'number') {
            const excelStartDate = new Date(Date.UTC(1900, 0, 1));  // Use UTC to avoid timezone effects
            excelStartDate.setUTCDate(excelStartDate.getUTCDate() + dateValue - 2); // Adjust for the 1900 leap year bug
            return this.formatDateString(excelStartDate, "number"); // Format as YYYY-MM-DD
        }

        // If it's a string, try to parse it as a date in multiple formats
        const parsedDate = this.tryParseDate(dateValue);
        if (parsedDate) {
            return this.formatDateString(parsedDate, "string"); // Format as YYYY-MM-DD
        } else {
            return "";  // Return empty if the value is not a valid date
        }
    };

    // Helper function to try parsing the date from multiple formats
    tryParseDate = (dateValue) => {
        // Try parsing a string as an ISO date format (YYYY-MM-DD)
        let parsedDate = new Date(dateValue);
        if (parsedDate instanceof Date && !isNaN(parsedDate)) {
            return parsedDate; // Return parsed date if valid
        }

        // If it doesn't work, try parsing using a format like '10 Nov 2024'
        parsedDate = Date.parse(dateValue);
        if (!isNaN(parsedDate)) {
            return new Date(parsedDate); // Return parsed date if valid
        }

        return null;  // Return null if the date can't be parsed
    };

    // Helper function to format the date object as YYYY-MM-DD
    formatDateString = (date, type) => {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
        let day = '';
        if (type === "number") {
            day = String(date.getUTCDate()).padStart(2, '0');
        } else {
            day = String(date.getUTCDate() + 1).padStart(2, '0');
        }
        return `${year}-${month}-${day}`;
    };

    // CHOOSE Resource COMPONENT
    chooseFileComponent = () => {
        return (
            <>
                <div className="import-info">
                    <div className="import-info-title ">
                        <p className="import-h5">Steps to import Resource Details:</p>
                    </div>
                    <ol className="instruction-list mt-2 mb-2">
                        <li>Resource Details can be imported in excel format.</li>
                        <li>Excel should be in specified format for import to work correctly.</li>
                        <li>Date format should be YYYY-MM-DD (Ex: 2022-03-01).</li>
                        <li>* indicate mandatory fields.</li>
                        <li>
                            Refer the below example while adding content to the excel.  &nbsp;
                            {/* onClick={() => this.props.export()} */}
                            <span className="download-links font-weight-bold" onClick={() => this.exportData()}>
                                Download Sample Excel File
                                &nbsp;<FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                            </span>
                            {this.props.csvLoading &&
                                <span> &nbsp;<FontAwesomeIcon icon={['fas', 'circle-notch']} size={'md'} className='rotate' style={{ color: '#0465AC' }} /></span>
                            }
                        </li>
                        <li>Select Institute to get Pre Requisite Data.
                            <select
                                className="form-control formControlContentTask"
                                style={{
                                    width: 'auto',
                                    height: '42px',
                                    fontSize: "13px",
                                    fontWeight: 400,
                                    lineHeight: '20px',
                                    fontFamily: "'Poppins', sans-serif",
                                    color: '#808080',
                                    borderRadius: '7px'
                                }}
                                onChange={(e) => {
                                    let selectedIIDValue = e.target.value;
                                    this.setState({ iidPreRequisiteData: selectedIIDValue }, () => {
                                        this.GetLibraryLocationList();  // location list
                                        this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
                                        this.apiCallToGetInstituteStreamList();  // department
                                        this.apiCallToGetAccessionSeries(); // accession series
                                        this.getPublisherList();  // publisher list
                                        this.getLibraryInvoiceListDataStatus();  // invoice data
                                    })
                                }}
                                value={this.state.iidPreRequisiteData}
                            >
                                {Object.values(this.props?.multipleInstituteDetails?.multipleInstituteDetails).map((member) => (
                                    <option key={member?.iid} value={member?.iid}>
                                        {member?.institute_name}
                                    </option>
                                ))}
                            </select>
                        </li>
                        <li>Refer the prerequire data to import.
                            &nbsp;
                            {/* <CSVLink
                                onFileLoaded={this.state.preRequisiteData}
                                data={this.state.preRequisiteData}
                                id='downloadPreRequisitePostEventDetails'
                                headers={this.state.preRequisiteHeaders}
                                filename={this.state.preRequisiteFileName}
                            > */}
                            <span
                                className={`download-links font-weight-bold ${(!this.state.loadingLocationData &&
                                    !this.state.loadingResourceCategoryData &&
                                    !this.state.loadingStreamData &&
                                    !this.state.loadingAccessionSeriesData &&
                                    !this.state.loadingPublisherDetails &&
                                    !this.state.loadingInvoiceData) ? 'download-links' : 'disabledLink'}`}
                                onClick={(resource) => {
                                    if (
                                        !this.state.loadingLocationData &&
                                        !this.state.loadingResourceCategoryData &&
                                        !this.state.loadingStreamData &&
                                        !this.state.loadingAccessionSeriesData &&
                                        !this.state.loadingPublisherDetails &&
                                        !this.state.loadingInvoiceData
                                    ) {
                                        // Allow the download
                                        // this.downloadPrerequisitedataCSV();
                                        this.exportPreRequisiteData()
                                    } else {
                                        // Prevent the download
                                        resource.preventDefault();
                                    }
                                }}
                            >
                                Download Prerequisite Excel File <FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                            </span>
                            {/* </CSVLink> */}
                        </li>
                    </ol>

                    <div className="import-info-preview">
                        {
                            this.state.csvData.length > 0 ? (
                                <div className="table-responsive" style={{ overflowY: 'auto', height: '250px' }}>
                                    <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                        <thead>
                                            {
                                                this.state.postResourceHeadersArray.map((item) => {
                                                    return (
                                                        <th>{item}</th>
                                                    )
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.postResourceDetailsArray.map((item, index) => {
                                                    if (item != undefined) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    this.state.postResourceHeadersArray.map((keys) => {
                                                                        if (typeof item[keys] == 'object') {
                                                                            return <td>{item[keys]['value']}</td>
                                                                        } else {
                                                                            return <td>{item[keys]}</td>
                                                                        }
                                                                    })
                                                                }

                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            ) : <span className="initial-preview"><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon><p className="mx-2">After choosing file, You can view content here.</p></span>
                        }

                    </div>

                </div>
                <div className="import-info-note mt-2 mb-3">
                    <p>Once you download the sample Excel file. Update the necessary content. In order to import the updated file you have to upload by clicking on the button mentioned below.</p>
                </div>
                <div className="import-body">
                    Select Institute to Import Resources
                    <select
                        className="form-control formControlContentTask"
                        style={{
                            width: 'auto',
                            height: '42px',
                            fontSize: "13px",
                            fontWeight: 400,
                            lineHeight: '20px',
                            fontFamily: "'Poppins', sans-serif",
                            color: '#808080',
                            borderRadius: '7px'
                        }}
                        onChange={(e) => {
                            let selectedIIDValue = e.target.value;
                            this.setState({ iidImportResource: selectedIIDValue }, () => {
                                this.ImportGetLibraryLocationList();  // location list
                                this.ImportGetLibraryResourceCategoryListWithBasicDetails();  // resource category
                                this.ImportapiCallToGetInstituteStreamList();  // department
                                this.ImportapiCallToGetAccessionSeries(); // accession series
                                this.ImportgetPublisherList();  // publisher list
                                this.ImportgetLibraryInvoiceListDataStatus();  // invoice data  
                            })
                        }}
                        value={this.state.iidImportResource}
                    >
                        {Object.values(this.props?.multipleInstituteDetails?.multipleInstituteDetails).map((member) => (
                            <option key={member?.iid} value={member?.iid}>
                                {member?.institute_name}
                            </option>
                        ))}
                    </select>
                    <div className="d-flex align-items-center flex-wrap">
                        <div style={{ display: "none" }}>
                            <form ref={this.myRef}>
                                <input
                                    type="file"
                                    id="react-excel-reader-input-resource"
                                    accept=".xlsx, .xls"
                                    onChange={this.handleExcelInput}
                                    style={{ display: 'none' }}
                                />
                            </form>
                            {/* <CSVReader
                                cssClass="csv-reader-input"
                                label="Select CSV file"
                                onFileLoaded={this.handleCSVInput}
                                parserOptions={papaparseOptions}
                            /> */}
                        </div>
                        <button type="button" className="btn import-btn" onClick={this.openFileInput} disabled={!this.state.iidImportResource}>
                            <FontAwesomeIcon icon={['fas', 'paperclip']} size={'lg'} color={"#FFF"}></FontAwesomeIcon> Choose File
                        </button>
                        {
                            Object.keys(this.state.selectedCSVFiles).length > 0 ?
                                <span>
                                    <span>
                                        {this.state.selectedCSVFiles['name']}
                                        <span style={{ "cursor": 'pointer' }} onClick={() => {
                                            this.removeCSVFile()
                                            this.myRef.current.reset()
                                        }}>
                                            <FontAwesomeIcon icon={['fas', 'times']} size={'md'}></FontAwesomeIcon>
                                        </span>
                                    </span>
                                </span>
                                : <p className="mb-0"><span className="text-danger">*</span> Please choose your excel file to import resource details</p>
                        }
                    </div>
                </div>
                {
                    this.state.csvData.length > 0 && !this.state.validations['isHeadersValid'] &&
                    <div className="alert alert-danger" style={{ maxHeight: '20vh', overflow: "auto" }}>
                        {
                            Object.values(this.state.validations['headersErrors']).map((item) => {
                                return <p className="text-danger my-2">Header {item.cell}-{item.message}</p>
                            })
                        }
                    </div>
                }
            </>
        )
    }

    // IMPORT CSV FILE COMPONENT 
    importCSVFileComponent = () => {
        return (
            <>
                <div className="previw-sheet" style={{ minHeight: '40vh' }}>
                    {
                        this.state.csvData.length > 0 ? (
                            <div className="table-responsive" >
                                <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                    <thead>
                                        <th className="td-dense">{"Sr. No."}</th>
                                        <th className="td-dense">{"Status"}</th>
                                        {/* {this.state.currentProgress == 0 ? "Error Location" : } */}
                                        {
                                            this.state.postResourceHeadersArray.map((item) => {
                                                return (
                                                    <th className="td-dense">
                                                        {item === 'Title' ? (
                                                            <>
                                                                {item} <span className="text-danger">*</span>
                                                            </>
                                                        ) : (
                                                            item
                                                        )}
                                                    </th>
                                                )
                                            })
                                        }
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.postResourceDetailsArray.map((item, index) => {
                                                if (item != undefined) {
                                                    return (

                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td className="td-dense">
                                                                {
                                                                    this.getCurrentStatusComponent(index, item['verificationStatus'], item['importStatus'])
                                                                }
                                                            </td>

                                                            {
                                                                this.state.postResourceHeadersArray.map((keys, cellIndex) => {

                                                                    // Multi select : Conditional logic based on 'keys'
                                                                    if (keys === "Publisher*") {
                                                                        multipleSelectOption = Object.values(this.state.publisherDataList).map(item => ({
                                                                            value: item.name,
                                                                            label: item.name,
                                                                        }));
                                                                    }
                                                                    else if (keys === "Resource Category*") {
                                                                        multipleSelectOption = Object.values(this.state.GetResourceCategoryList).flatMap(item => {
                                                                            // Start with the category itself
                                                                            const categoryOption = {
                                                                                value: item.name,
                                                                                label: item.name,
                                                                                isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
                                                                            };

                                                                            // If the category has subcategories, add those as well
                                                                            const subCategoryOptions = item.subCategories.map(subCategory => ({
                                                                                value: subCategory.subCategoryName,
                                                                                label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                                                                                isDisabled: false, // Subcategory is always enabled
                                                                            }));

                                                                            // Return the category option followed by the subcategory options
                                                                            return [categoryOption, ...subCategoryOptions];
                                                                        });
                                                                    }
                                                                    else if (keys === "Department") {
                                                                        multipleSelectOption = Object.values(this.state.GetStreamList).map(item => ({
                                                                            value: item.name,
                                                                            label: item.name,
                                                                        }));
                                                                    }

                                                                    // Check if item[keys] is a string before using split
                                                                    let itemValues = [];
                                                                    if (typeof item[keys] === 'string') {
                                                                        // If it's a string, split it by commas
                                                                        itemValues = item[keys].split(',').map(val => val.trim());
                                                                    } else if (Array.isArray(item[keys])) {
                                                                        // If it's already an array, just use it
                                                                        itemValues = item[keys];
                                                                    }

                                                                    // Create options array based on itemValues
                                                                    const options = itemValues.map(value => ({
                                                                        value: value,
                                                                        label: value, // or any other custom label format
                                                                    }));

                                                                    // Filter selectedOption from options based on matching values
                                                                    const selectedOption = options.filter(option => itemValues.includes(option.value));

                                                                    // Check if the selected options are valid (i.e., present in multipleSelectOption)
                                                                    const isValidSelection = selectedOption.length > 0 && selectedOption.every(option => multipleSelectOption.some(opt => opt.value === option.value));

                                                                    // Handle invalid Department values by clearing them
                                                                    if (keys === "Department" && !isValidSelection) {
                                                                        item["Department"] = []; // Clear invalid department values
                                                                    }

                                                                    // Handle invalid Category values by clearing them
                                                                    if (keys === "Resource Category*" && !isValidSelection) {
                                                                        item["Resource Category*"] = []; // Clear invalid department values
                                                                    }

                                                                    // Handle invalid Publisher values by clearing them
                                                                    if (keys === "Publisher*" && !isValidSelection) {
                                                                        item["Publisher*"] = []; // Clear invalid department values
                                                                    }

                                                                    // If no valid match is found, show the error message and clear the selection
                                                                    const showErrorMessage = itemValues.length > 0 && !isValidSelection;
                                                                    const clearSelection = !isValidSelection ? [] : selectedOption;

                                                                    // Determine if the row is disabled based on the status
                                                                    const isRowDisabled = item['importStatus'] === 'success';
                                                                    const isInputFieldDisable = item['importStatus'] === 'success' || keys === 'Net Price (In Rs)'

                                                                    // single select dropdown check
                                                                    let isSingleSelectValid = true;
                                                                    let dropdownOptions = [];

                                                                    if (keys === "Accession Series*") {
                                                                        dropdownOptions = Object.values(this.state.accessionSeriesList).map(opt => opt.label);
                                                                        isSingleSelectValid = dropdownOptions.includes(item[keys]);
                                                                        // If invalid, clear the field
                                                                        if (!isSingleSelectValid) {
                                                                            item["Accession Series*"] = '';
                                                                        }
                                                                    } else if (keys === "Resource Language*") {
                                                                        dropdownOptions = resourceLanguageData;
                                                                        isSingleSelectValid = dropdownOptions.includes(item[keys]);
                                                                        // If invalid, clear the field
                                                                        if (!isSingleSelectValid) {
                                                                            item["Resource Language*"] = '';
                                                                        }
                                                                    } else if (keys === "Resource Type*") {
                                                                        dropdownOptions = resourceTypeData;
                                                                        isSingleSelectValid = dropdownOptions.includes(item[keys]);
                                                                        // If invalid, clear the field
                                                                        if (!isSingleSelectValid) {
                                                                            item["Resource Type*"] = '';
                                                                        }
                                                                    } else if (keys === "Location") {
                                                                        dropdownOptions = [];
                                                                        Object.values(this.state.GetLocationList).forEach(loc => {
                                                                            if (!loc.sublocations?.length) dropdownOptions.push(loc.name);
                                                                            loc.sublocations?.forEach(sub => dropdownOptions.push(sub.sublocationName));
                                                                        });
                                                                        isSingleSelectValid = dropdownOptions.includes(item[keys]);

                                                                        // If invalid, clear the field
                                                                        if (!isSingleSelectValid) {
                                                                            item["Location"] = '';
                                                                        }
                                                                    } else if (keys === "Resource Condition") {
                                                                        dropdownOptions = resourceConditionData;
                                                                        isSingleSelectValid = dropdownOptions.includes(item[keys]);
                                                                        // If invalid, clear the field
                                                                        if (!isSingleSelectValid) {
                                                                            item["Resource Condition"] = '';
                                                                        }
                                                                    } else if (keys === "Invoice/Bill No") {
                                                                        dropdownOptions = Object.values(this.state.GetInvoiceDataList).map(opt => String(opt.billno));
                                                                        isSingleSelectValid = dropdownOptions.includes(String(item[keys]));
                                                                        // If invalid, clear the field
                                                                        if (!isSingleSelectValid) {
                                                                            item["Invoice/Bill No"] = '';
                                                                        }
                                                                    }

                                                                    return (
                                                                        <td className={this.state.currentErrorObject['row'] == index ? "td-dense-highlight" : "td-dense"}>
                                                                            <div className={this.state.currentErrorObject['row'] == index ? "table-row-highlighter" : ""}>
                                                                                {
                                                                                    keys == "Accession Series*" || keys == "Resource Language*" || keys == "Resource Type*" || keys == "Location" || keys == "Resource Condition" || keys == "Invoice/Bill No" ?
                                                                                        <>
                                                                                            <select
                                                                                                id="series-selction"
                                                                                                value={item[keys]} // Set the selected value
                                                                                                className="form-control"
                                                                                                onChange={(e) => {
                                                                                                    this.getValueOfRowInputs(index, keys, e.target.value, keys);
                                                                                                }}
                                                                                                disabled={isRowDisabled}
                                                                                                style={{
                                                                                                    width: "max-content"
                                                                                                }}
                                                                                            >
                                                                                                <option value="">{item[keys] ? `Select ${keys}` : keys}</option>

                                                                                                {/* When keys are "Accession Series*" */}
                                                                                                {keys === "Accession Series*" &&
                                                                                                    Object.values(this.state.accessionSeriesList).map((data) => {
                                                                                                        const label = data.label.length > 20 ? data.label.slice(0, 20) + '...' : data.label;
                                                                                                        return (
                                                                                                            <option key={data.value} value={data.label} title={data.label}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }

                                                                                                {/* When keys are "Resource Language*" */}
                                                                                                {keys === "Resource Language*" &&
                                                                                                    resourceLanguageData.map((data, index) => {
                                                                                                        const label = data.length > 20 ? data.slice(0, 20) + '...' : data;
                                                                                                        return (
                                                                                                            <option key={index} value={data}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }

                                                                                                {/* When keys are "Resource Type*" */}
                                                                                                {keys === "Resource Type*" &&
                                                                                                    resourceTypeData.map((data, index) => {
                                                                                                        const label = data.length > 20 ? data.slice(0, 20) + '...' : data;
                                                                                                        return (
                                                                                                            <option key={index} value={data} title={data}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }

                                                                                                {/* When keys are "Location" */}
                                                                                                {keys === "Location" &&
                                                                                                    Object.values(this.state.GetLocationList)?.map((data) => {
                                                                                                        return (
                                                                                                            <>
                                                                                                                {/* Disable the parent location if it has sublocations */}
                                                                                                                <option
                                                                                                                    key={data.value}
                                                                                                                    value={data.name}
                                                                                                                    disabled={data.sublocations && data.sublocations.length > 0}
                                                                                                                    title={data.name}
                                                                                                                >
                                                                                                                    {data.name.length > 25 ? data.name.slice(0, 25) + '...' : data.name}
                                                                                                                </option>

                                                                                                                {data.sublocations && data.sublocations.length > 0 &&
                                                                                                                    data.sublocations.map((sublocation) => {
                                                                                                                        const subLocationLabel = `${data.name} => ${sublocation.sublocationName}`;
                                                                                                                        return (
                                                                                                                            <option
                                                                                                                                key={sublocation.sublocationId}
                                                                                                                                value={sublocation.sublocationName}
                                                                                                                                title={subLocationLabel} // Full name for tooltip on hover
                                                                                                                            >
                                                                                                                                {/* {data.name} ={'>'} {sublocation.sublocationName} */}
                                                                                                                                {subLocationLabel.length > 20 ? subLocationLabel.slice(0, 20) + '...' : subLocationLabel}
                                                                                                                            </option>
                                                                                                                        );
                                                                                                                    })
                                                                                                                }
                                                                                                            </>
                                                                                                        );
                                                                                                    })
                                                                                                }

                                                                                                {/* When keys are "Resource Condition" */}
                                                                                                {keys === "Resource Condition" &&
                                                                                                    resourceConditionData.map((data, index) => {
                                                                                                        const label = data.length > 20 ? data.slice(0, 20) + '...' : data;
                                                                                                        return (
                                                                                                            <option key={index} value={data} title={data}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }

                                                                                                {/* When keys are "Invoice/Bill No" */}
                                                                                                {keys === "Invoice/Bill No" &&
                                                                                                    Object.values(this.state.GetInvoiceDataList).map((data) => {
                                                                                                        const label = data.billno.length > 20 ? data.billno.slice(0, 20) + '...' : data.billno;
                                                                                                        return (
                                                                                                            <option key={data.value} value={data.billno} title={data.billno}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }
                                                                                            </select>

                                                                                            {!isSingleSelectValid && (
                                                                                                <span className="text-danger">Please select valid {keys}</span>
                                                                                            )}
                                                                                        </>
                                                                                        :
                                                                                        keys == "Publisher*" || keys == "Resource Category*" || keys == "Department" ?
                                                                                            <>
                                                                                                <Select
                                                                                                    isMulti
                                                                                                    options={multipleSelectOption}
                                                                                                    value={clearSelection}
                                                                                                    onChange={(e) => {
                                                                                                        this.getValueOfMultipleSelect(index, keys, e);
                                                                                                    }}
                                                                                                    isSearchable
                                                                                                    onInputChange={(inputValue) => {
                                                                                                    }}
                                                                                                    onKeyDown={(event) => {
                                                                                                    }}
                                                                                                    className='basic-multi-select'
                                                                                                    // Apply custom styles to the dropdown
                                                                                                    styles={{
                                                                                                        control: (base) => ({
                                                                                                            ...base,
                                                                                                            width: '100%',
                                                                                                            minHeight: 42, // Minimum height for the control area
                                                                                                            height: 'auto', // Allow control to grow dynamically
                                                                                                        }),
                                                                                                        multiValue: (base) => ({
                                                                                                            ...base,
                                                                                                            backgroundColor: 'none',
                                                                                                            borderRadius: '5px',
                                                                                                            border: '1px solid #c4c5c5',
                                                                                                            fontSize: '12px',
                                                                                                            fontWeight: '400',
                                                                                                            color: '#808080',
                                                                                                            display: 'inline-flex',
                                                                                                            margin: '2px',
                                                                                                            whiteSpace: 'nowrap',
                                                                                                        }),
                                                                                                        multiValueContainer: (base) => ({
                                                                                                            ...base,
                                                                                                            display: 'flex',
                                                                                                            flexWrap: 'wrap',
                                                                                                            overflowX: 'auto', // Horizontal scroll when values overflow
                                                                                                            minHeight: 42, // Ensure consistent height when values are selected
                                                                                                        }),
                                                                                                        menu: (base) => ({
                                                                                                            ...base,
                                                                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                                                        }),
                                                                                                        menuPortal: (base) => ({
                                                                                                            ...base,
                                                                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                                                        }),
                                                                                                        placeholder: (base) => ({
                                                                                                            ...base,
                                                                                                            fontSize: '12px',
                                                                                                            fontWeight: '400',
                                                                                                        }),
                                                                                                        option: (base, state) => ({
                                                                                                            ...base,
                                                                                                            fontSize: '12px',
                                                                                                            fontWeight: '400',
                                                                                                            backgroundColor: state.isDisabled ? '#f0f0f0' : state.isFocused ? '#e0e0e0' : 'white',
                                                                                                            color: state.isDisabled ? '#999' : '#555',
                                                                                                            cursor: state.isDisabled ? 'not-allowed' : 'default',
                                                                                                        }),
                                                                                                    }}
                                                                                                    // Specify that the menu should be rendered in the document body
                                                                                                    menuPortalTarget={document.body}
                                                                                                    isDisabled={isRowDisabled}
                                                                                                />

                                                                                                {
                                                                                                    showErrorMessage && (
                                                                                                        <span className="text-danger" style={{ marginTop: '4px', display: 'block' }}>
                                                                                                            Please select valid {keys}
                                                                                                        </span>
                                                                                                    )
                                                                                                }

                                                                                            </>
                                                                                            :
                                                                                            <input
                                                                                                type='text'
                                                                                                placeholder={`Enter ${keys}`}
                                                                                                value={item[keys]}
                                                                                                ref={(el) => this.tableObject[`${index}-${cellIndex}`] = el}
                                                                                                style={{ width: '200px' }} // Correct way to apply inline style as an object
                                                                                                className="form-control filterInput"
                                                                                                onChange={(e) => {
                                                                                                    const value = e.target.value;

                                                                                                    // If field is "Year of Publication", validate input
                                                                                                    if (keys === 'Year of Publication') {
                                                                                                        const isValid = /^\d{0,4}(-(\d{0,2}|\d{0,4}))?$/.test(value);
                                                                                                        if (!isValid) return; // Block invalid input
                                                                                                    }

                                                                                                    this.getValueOfRowInputs(index, keys, value, keys);
                                                                                                }}
                                                                                                disabled={isInputFieldDisable}
                                                                                            />
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    )
                                                }
                                            })
                                        }

                                    </tbody>
                                </table>
                            </div>
                        ) : <p>Data is not available.</p>
                    }
                </div>
                <p><span className="text-danger my-2 font-size14">*</span>Note : Errors are indicated by red boxes. Please click on the red boxes to correct them. </p>

                <div className="inspect-console">
                    <div className="table-responsive">
                        <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                            <thead>
                                <tr>
                                    <th rowSpan={2} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        <div className="import-progress">
                                            {
                                                this.state.importProgress.map((item, index) => {
                                                    return (
                                                        <div className="tab-wrapper">
                                                            <div className="step-wrapper">
                                                                <span className={this.state.currentProgress == index ? "circle-tab" : "circle-tab-muted"} style={this.checkImportTabProgress(index) ? { background: "green", color: "#FFF" } : {}}>{index + 1}</span>
                                                                {index < this.state.importProgress.length - 1 && <span className={this.state.validations['isVerified'] ? "step-line bg-success" : "step-line "}></span>}
                                                            </div>
                                                            <p className={this.state.currentProgress == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p>
                                                        </div>

                                                    )
                                                })
                                            }
                                        </div>
                                    </th>

                                    <th>
                                        <div className="d-flex justify-content-between align-items-center" >
                                            <span onClick={() => {
                                                this.state.currentPointer > 0 && this.navigateToPreviousError()
                                            }} disabled={true} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-left']} size="md"></FontAwesomeIcon></span>
                                            <p className="mb-0 font-weight-bold">Error Location :
                                                {Object.keys(this.state.currentErrorObject).length > 0 &&
                                                    `Rows : ${this.state.currentErrorObject['row'] + 1} Columns : ${this.state.currentErrorObject['key']}`
                                                }
                                            </p>
                                            <span onClick={() => {
                                                this.state.currentPointer < this.state.errorLogs.length && this.navigateToNextError()
                                            }} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-right']} size="md"></FontAwesomeIcon></span>
                                        </div>
                                    </th>
                                </tr>
                                <tr>

                                    <th align="center" style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        {
                                            this.state.errorLogs.length > 0 ?
                                                (
                                                    <div>{this.ErrorViewConsole()}</div>
                                                )
                                                : <span className="initial-preview"><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon><p className="mx-2 mb-0">After verification, You can view content which has errors.</p></span>
                                        }
                                        {/* 
										{
											this.state.errorMessageObjArray?.length > 0 ?
												this.state.errorMessageObjArray?.map((row) => {
													let rowIndex = row['rowIndex'];
													let message = row['message'];
													return <div>Row : {rowIndex} | Error : {message}</div>;
												})
												:
												<span className="initial-preview">
													<FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999" />
													<p className="mx-2 mb-0">After verification, You can view content which has errors.</p>
												</span>
										} */}

                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </>
        )
    }

    // 	GET CURRENT STATUS COMPONENT
    getCurrentStatusComponent = (index, verificationStatus = "pending", importStatus = "pending") => {
        {
            return this.state.importPointer['rowindex'] == index ?
                <div>
                    {
                        this.state.importPointer['loading'] ?
                            <div class="spinner-border spinner-border-sm" role="status" >
                                <span class="sr-only">{this.state.importPointer['status']}...</span>
                            </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div>{this.state.importPointer['status'].charAt(0).toUpperCase() + this.state.importPointer['status'].slice(1)}</div>
                                {/* <div>{this.state.importPointer['status']}</div> */}
                                {/* {
                                    this.state.importPointer['status'] == 'failed' &&
                                    // importStatus == 'failed' &&
                                    <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                                        this.setState({
                                            loadingImportProcess: true
                                        }, () => {
                                            this.apiCallToImportVerifyResourceDetails(index, this.state.importProgressSummary, 'true')
                                        })
                                    }>
                                        Retry
                                    </button>
                                } */}
                            </div>

                    }

                </div>

                : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div>{importStatus.charAt(0).toUpperCase() + importStatus.slice(1)}</div>

                    {/* {
                        // this.state.importPointer['status'] == 'failed' &&
                        importStatus == 'failed' &&
                        <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                            this.setState({
                                loadingImportProcess: true
                            }, () => {
                                this.apiCallToImportVerifyResourceDetails(index, this.state.importProgressSummary, 'true')
                            })
                        }>
                            Retry
                        </button>
                    } */}
                </div>
        }
    }

    //function to download prerequisite data 
    downloadPrerequisitedataCSV = () => {
        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty
        let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForFaculty

        // For Department
        if (Object.values(this.state.GetStreamList).length > 0) {
            Object.keys(this.state.GetStreamList).map((stream, index) => {
                let branch = this.state.GetStreamList[stream]
                if (branch != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].branch = branch.name
                    } else {
                        preRequisiteData.push({ periodicity: '', category: '', department: branch.name })
                    }
                }
            })
        }

        // For categoryList
        if (Object.values(this.state.categoryList).length > 0) {
            Object.keys(this.state.categoryList).map((Id, index) => {
                let category = this.state.categoryList[Id]
                if (category != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].category = category.category_name
                    } else {
                        preRequisiteData.push({ periodicity: '', category: category.category_name, department: '' })
                    }
                }
            })
        }

        this.setState({
            preRequisiteData: preRequisiteData,
            preRequisiteHeaders: preRequisiteHeaders,
        })
    }
    // Strip HTML
    stripHtml(html) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    //FUNCTION DEFINED TO GET THE INPUT OF THE IMPORTED CSV
    handleCSVInput = (csvData, fileInformation) => {

        this.setState({
            selectedCSVFiles: fileInformation
        })

        if (fileInformation.type !== "text/csv") {
            this.setState({
                selectedCSVFiles: {},
                successModal: true,
                successModalType: "error",
                successMessage: "Please select csv file.",
                isValidAttachment: false
            })
        } else {
            let postResourceDetailsArray = [];
            let postResourceHeadersArray = [];

            if (csvData.length > 0) {
                csvData = csvData.filter((rowArray, index) => rowArray.length > 1 && !rowArray.every((val) => val == ""));

                // Read CSV Headers
                let headers = csvData[0];

                if (headers != undefined && headers.length > 0) {
                    headers.map((headerName, index) => {
                        if (headerName != undefined) {
                            postResourceHeadersArray.push(headerName.trim());
                        }
                    })
                }

                // Read CSV Actual Body Data
                if (postResourceHeadersArray.length > 0) {
                    csvData.map((csvRow, index) => {
                        if (index != 0) {
                            let challanObject = {};
                            let totalDeduction = 0;

                            for (let i = 0; i < postResourceHeadersArray.length; i++) {

                                if (csvRow[i] == undefined || csvRow[i] == null || csvRow[i] == "") {
                                    challanObject[postResourceHeadersArray[i]] = "";
                                } else {
                                    challanObject[postResourceHeadersArray[i]] = csvRow[i];
                                }
                            }

                            if (challanObject['Gross Pay'] != undefined) {
                                challanObject['Net Pay'] = parseFloat(challanObject['Gross Pay']) - totalDeduction;
                            }

                            postResourceDetailsArray.push({ ...challanObject, verificationStatus: "pending", importStatus: "pending", loading: false });
                        }
                    })
                }
            }

            this.setState({
                csvData: [...csvData],
                postResourceDetailsArray: postResourceDetailsArray,
                postResourceHeadersArray: postResourceHeadersArray
            }, () => {
                this.validateCSVFileHeaders();

            })
        }
    }

    // VALIDATE CSV FILE HEADERS
    validateCSVFileHeaders = () => {
        let commonHeaders = [
            "Accession Series*", "Accession Number*", "Accession Date", "Call Number", "Title*", "Author Name*", "Resource Volume", "Resource Edition", "Resource Language*", "Publisher*", "Number of Pages", "Number of Preliminary Pages", "Resource Category*", "Year of Publication", "Department", "Resource Type*", "Translator Name", "Translated", "Search Keyword", "Resource Medium", "Location", "ISBN Number", "Resource Condition", "Invoice/Bill No", "Invoice/ Bill Date", "Price (In Rs)", "Discount (In %)", "Net Price (In Rs)"
        ]
        let mandatoryHeaders = ["Accession Series*", "Accession Number*", "Title*", "Author Name*", "Resource Language*", "Publisher*", "Resource Category*", "Resource Type*",]
        let postResourceHeadersArray = this.state.postResourceHeadersArray;
        let validations = this.state.validations;

        if (postResourceHeadersArray.length > 0) {
            // Checking Default resource Headers are available or not.
            mandatoryHeaders.map((header, index) => {
                if (!postResourceHeadersArray.includes(header)) {
                    let validationObject = {
                        touch: true,
                        cell: index + 1,
                        row: 0,
                        status: "error",
                        message: `${header} is mandatory column to import update resource.`,
                        type: "header",
                        errorCount: 0
                    }
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }
            })

            // Checking Dyanamic resource Headers are available or not.
            postResourceHeadersArray.map((key, index) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    status: "error",
                    message: "",
                    type: "header",
                    errorCount: 0
                }

                let isValidHeader = commonHeaders.some((keys) => {
                    return keys == key.trim();
                })

                let validationMessage = '';
                if (key) {
                    validationMessage = ` ${key} header is invalid.`
                } else {
                    validationMessage = ` ${key} header is missing.`
                }

                if (!isValidHeader) {
                    validationObject.cell = index;
                    validationObject.status = "error";
                    validationObject.message = `Please check default headers. ${validationMessage}`;
                    validationObject.touch = true;
                }


                if (validationObject.touch) {
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }

            })
        }


        if (validations['headersErrors'].length == 0) {
            validations['isHeadersValid'] = true;
        }

        this.setState({
            validations: { ...validations }
        })
    }

    // VALIDATE CSV FILE DATA
    validateCSVFileData = () => {
        let postResourceDetailsArray = this.state.postResourceDetailsArray;
        let postResourceHeadersArray = this.state.postResourceHeadersArray;
        let validations = { ...this.state.validations, dataErrors: {}, errors: [], isDataValid: false, isVerified: false };
        let verificationSummary = {
            completed: 0,
            failed: 0,
            total: 0,
            pending: 0
        };

        verificationSummary['total'] = postResourceDetailsArray.length;
        verificationSummary['pending'] = postResourceDetailsArray.length;
        let verificationPointer = this.state.verificationPointer;

        postResourceDetailsArray.map((item, rowIndex) => {
            let status = true;
            let hasEarning = true;
            verificationPointer['loading'] = true;
            verificationPointer['status'] = 'verfying';
            verificationPointer['rowindex'] = rowIndex;
            this.setState({
                verificationPointer: verificationPointer
            })

            verificationSummary['pending'] -= verificationSummary['pending'];

            postResourceHeadersArray.map((key, cellIndex) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "",
                    type: "data",
                    errorCount: 0
                }

                if (validationObject.touch) {
                    status = false;
                    if (validations['dataErrors'][rowIndex] == undefined) {
                        validations['dataErrors'][rowIndex] = {};
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;

                    } else {
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;
                    }
                    item['verificationStatus'] = "failed";
                    validations['isDataValid'] = false;
                }
            })

            if (hasEarning) {
                validations['errors'].push({
                    touch: true,
                    cell: 0,
                    row: rowIndex,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "Please enter atleast one earning component",
                    type: "basic",
                    errorCount: 1
                })

                verificationPointer['status'] = 'failed';
                postResourceDetailsArray[rowIndex]['verificationStatus'] = 'failed';
                verificationPointer['loading'] = false;
            } else {
                verificationPointer['status'] = status ? 'verified' : 'failed';
                postResourceDetailsArray[rowIndex]['verificationStatus'] = verificationPointer['status'];
                verificationPointer['loading'] = false;
            }

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];

            this.setState({
                postResourceDetailsArray: [...postResourceDetailsArray],
                verificationProgress: verificationSummary,
                verificationPointer: verificationPointer,
            })
        })

        if (validations['errors'].length > 0) {
            let failedCount = 0;
            validations['errors'].map(item => {
                if (!Object.keys(validations['dataErrors']).includes(item.row)) {
                    failedCount++;
                }
            })

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length + failedCount;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];
        }


        if (Object.keys(validations['dataErrors']).length == 0 && validations['errors'].length == 0) {
            validations['isDataValid'] = true;
            validations['isVerified'] = true;
            this.setState({
                currentPointer: 1
            })
        }

        this.setState({
            validations: { ...validations },
            verificationProgress: verificationSummary,
            loadingVerificationProcess: false
        }, () => {
            this.getBugLogs();
        })
    }

    // GET VALUES FORM INPUT FIELDS
    getValueOfRowInputs = (rowIndex, key, value, type) => {
        // let postResourceDetailsArray = this.state.postResourceDetailsArray;
        // let rowObject = postResourceDetailsArray[rowIndex];
        // if (typeof rowObject[key] == 'object') {
        //     rowObject[key]['value'] = value;
        // } else {
        //     rowObject[key] = value;
        // }

        // postResourceDetailsArray[rowIndex] = rowObject;

        // this.setState({
        //     postResourceDetailsArray: postResourceDetailsArray
        // })
        let postResourceDetailsArray = this.state.postResourceDetailsArray;
        let rowObject = postResourceDetailsArray[rowIndex];
        // if (typeof rowObject[key] == 'object') {
        //     rowObject[key]['value'] = value; // Update nested value if it's an object
        // } else {
        //     rowObject[key] = value; // Update directly if it's a primitive
        // }

        if (key === "Invoice/Bill No" && Object.values(this.state.GetInvoiceDataList)  && value) {
            // Assuming invoiceData is an array of objects where each object has "billno" and "billDate"
            const selectedInvoice = Object.values(this.state.GetInvoiceDataList).find(item => item.billno === value);
            if (selectedInvoice) {
                // Update both "Invoice/Bill No" and "Invoice/ Bill Date"
                rowObject["Invoice/Bill No"] = value;
                rowObject["Invoice/ Bill Date"] = selectedInvoice.billdate || ''; // Set the corresponding date
            }
        } else {
            // Handle other cases
            if (typeof rowObject[key] == 'object') {
                rowObject[key]['value'] = value; // Update nested value if it's an object
            } else {
                rowObject[key] = value; // Update directly if it's a primitive
            }
        }

        // Calculate Net Price only if price and/or discount changed
        if (key === "Price (In Rs)" || key === "Discount (In %)") {
            const price = parseFloat(rowObject["Price (In Rs)"]);
            const discount = parseFloat(rowObject["Discount (In %)"]);

            if (!isNaN(price)) {
                let netPrice = price;

                if (!isNaN(discount) && discount > 0) {
                    netPrice = price - ((price * discount) / 100);
                }

                rowObject["Net Price (In Rs)"] = netPrice.toFixed(2); // Set Net Price
            } else {
                rowObject["Net Price (In Rs)"] = ""; // Reset if price is invalid
            }
        }

        postResourceDetailsArray[rowIndex] = rowObject;

        this.setState({
            postResourceDetailsArray: postResourceDetailsArray
        });
    }

    // GET VALUES FORM Multi-Select FIELDS
    getValueOfMultipleSelect = (rowIndex, key, selectedOptions) => {
        let postResourceDetailsArray = this.state.postResourceDetailsArray;
        let rowObject = postResourceDetailsArray[rowIndex];

        // If the selected options are not empty, update the row object with the selected values
        if (selectedOptions && selectedOptions.length > 0) {
            rowObject[key] = selectedOptions.map(option => option.value); // Set selected values as an array
        } else {
            rowObject[key] = []; // If no options are selected, set it to an empty array
        }

        postResourceDetailsArray[rowIndex] = rowObject;

        this.setState({
            postResourceDetailsArray: postResourceDetailsArray
        });
    }

    // Navigate to previous 
    navigateToPreviousError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer > 0) {
            currentPointer -= 1;
            currentErrorObject = errorLogs[currentPointer];
            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }

    }

    // Navigate to next
    navigateToNextError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer < errorLogs.length - 1) {

            currentPointer += 1;
            currentErrorObject = errorLogs[currentPointer];

            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }
    }

    // CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
            successModalType: "",
            successMessage: ""
        })
    }

    // CONSOLE ERROR 
    ErrorViewConsole = () => {
        let { row, message } = this.state.currentErrorObject;
        return (
            <div>
                {
                    this.state.currentErrorObject['key'] != "" && (
                        <div>
                            <p className="mb-0 font-weight-bold text-danger">{this.state.currentErrorObject['message']}</p>
                        </div>
                    )

                }
            </div>
        )
    }

    // API CALL TO IMPORT VERIFY RESOURCE
    apiCallToImportVerifyResourceDetails = async (rowIndex = 0, importProgressSummary = { completed: 0, failed: 0, total: 0, pending: 0 }, isRetry = "") => {

        if (rowIndex < this.state.postResourceDetailsArray.length) {
            let resourceData = this.state.postResourceDetailsArray[rowIndex];
            let importPointer = this.state.importPointer;
            importPointer['loading'] = true;
            importPointer['status'] = 'importing';
            importPointer['rowindex'] = rowIndex;
            this.setState({
                importPointer: importPointer,
            })

            let publisherData = [];
            let categoryData = [];
            let departmentData = [];

            // publisher data
            if (typeof resourceData['Publisher*'] === 'string') {
                // If it's a string, split it by commas
                publisherData = resourceData['Publisher*'].split(',').map(val => val.trim());
            } else {
                publisherData = resourceData['Publisher*']
            }

            // category data
            if (typeof resourceData['Resource Category*'] === 'string') {
                // If it's a string, split it by commas
                categoryData = resourceData['Resource Category*'].split(',').map(val => val.trim());
            } else {
                categoryData = resourceData['Resource Category*']
            }

            // department/stream data
            if (typeof resourceData['Department'] === 'string') {
                // If it's a string, split it by commas
                departmentData = resourceData['Department'].split(',').map(val => val.trim());
            } else {
                departmentData = resourceData['Department']
            }


            let accessionSeriesName = resourceData['Accession Series*'] ? (resourceData['Accession Series*']) : "";
            let accessionNumber = resourceData['Accession Number*'] ? (resourceData['Accession Number*']) : "";
            let FormattedAccessionDate = resourceData['Accession Date'] ? resourceData['Accession Date'] : "";
            let callNumber = resourceData['Call Number'] ? (resourceData['Call Number']) : "";
            let titleName = resourceData['Title*'] ? (resourceData['Title*']) : "";
            let authorName = resourceData['Author Name*'] ? (resourceData['Author Name*']) : "";
            let volumeName = resourceData['Resource Volume'] ? (resourceData['Resource Volume']) : "";
            let editionName = resourceData['Resource Edition'] ? (resourceData['Resource Edition']) : "";
            let resourceLanguageName = resourceData['Resource Language*'] ? (resourceData['Resource Language*']) : "";
            let publisherName = resourceData['Publisher*'] ? publisherData : [];
            let NoOfPages = resourceData['Number of Pages'] ? (resourceData['Number of Pages']) : "";
            let preliminaryPages = resourceData['Number of Preliminary Pages'] ? (resourceData['Number of Preliminary Pages']) : "";
            let categoryName = resourceData['Resource Category*'] ? categoryData : [];
            let yearOfPublication = resourceData['Year of Publication'] ? (resourceData['Year of Publication']) : "";
            let streamIdName = resourceData['Department'] ? departmentData : [];
            let resourceTypeName = resourceData['Resource Type*'] ? (resourceData['Resource Type*']) : "";
            let translatorName = resourceData['Translator Name'] ? (resourceData['Translator Name']) : "";
            let isTranslated = resourceData['Translated'] ? (resourceData['Translated']) : ("Yes");
            let keywordName = resourceData['Search Keyword'] ? (resourceData['Search Keyword']) : "";
            let locationName = resourceData['Location'] ? (resourceData['Location']) : "";
            let isbnNumber = resourceData['ISBN Number'] ? (resourceData['ISBN Number']) : "";
            let resourceConditionName = resourceData['Resource Condition'] ? (resourceData['Resource Condition']) : ("Good");
            let invoiceNumber = resourceData['Invoice/Bill No'] ? (resourceData['Invoice/Bill No']) : "";
            let priceData = resourceData['Price (In Rs)'] ? (resourceData['Price (In Rs)']) : "";
            let discountData = resourceData['Discount (in %)'] ? (resourceData['Discount (in %)']) : "";
            let netPrice = resourceData['Net Price (In Rs)'] ? (resourceData['Net Price (In Rs)']) : "";
            let invoiceDate = invoiceNumber ? (resourceData['Invoice/ Bill Date']) : "";


            let errorLogs = this.state.errorLogs;

            let requestData = {
                "iid": this.state.iidImportResource, //config.institute_id,
                "facultyId": config.faculty_id,
                "resourceMedium": "Physical",
                "accessionNumber": accessionNumber,
                "accessionDate": FormattedAccessionDate,
                "callNumber": callNumber,
                "title": titleName,
                "author": authorName,
                "volume": volumeName,
                "edition": editionName,
                "resourceLanguage": resourceLanguageName,
                "numberOfPages": NoOfPages,
                "preliminaryPages": preliminaryPages,
                "resourceCategoryNameArr": categoryName,
                "yearOfPublication": yearOfPublication,
                "resourceType": resourceTypeName,
                "translatorName": translatorName,
                "translated": isTranslated,
                "keyword": keywordName,
                "isbnNumber": isbnNumber,
                "resourceCondition": resourceConditionName,
                "invoiceDate": invoiceDate,
                "price": priceData,
                "discount": discountData,
                "netPrice": netPrice,
                "accessionSeriesName": accessionSeriesName,
                "publishersNameArr": publisherName,
                "streamNameArr": streamIdName,
                "locationName": locationName,
                "invoiceNo": invoiceNumber,
                "iidArray": this.props.iidArray.iidArray
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'library_VerifyImportResource',
                requestData,
                "/api/library/instructor.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToImportVerifyResourceDetails(rowIndex, importProgressSummary, isRetry);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    // set response
                    // this.setState(prevState => ({
                    //     verifyImportResourceResult: [...prevState.verifyImportResourceResult, apiResult]
                    // }));
                    this.setState({
                        verifyImportResourceResult: apiResult
                    })
                    if (apiResult.status == 'success') {
                        let postResourceDetailsArray = this.state.postResourceDetailsArray;
                        let rowItem = postResourceDetailsArray[rowIndex];

                        rowItem['status'] = 'completed'
                        postResourceDetailsArray[rowIndex] = rowItem;

                        importProgressSummary['completed'] += 1;
                        if (isRetry != "true") {

                            importProgressSummary['pending'] -= 1;
                        } else {
                            importProgressSummary['failed'] -= 1;
                        }

                        importPointer['status'] = 'success';
                        postResourceDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;


                        let findIndex = errorLogs.findIndex(obj => obj.row == rowIndex)

                        if (findIndex != -1) {
                            errorLogs.splice(findIndex, 1);
                        }


                        this.setState({
                            postResourceDetailsArray: postResourceDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentPointer: 0,
                            currentErrorObject: errorLogs.length > 0 ? errorLogs[0] : {}
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportVerifyResourceDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                    else {
                        // let rowIndex = rowIndex + 1;
                        let errorObj = {};
                        errorObj['row'] = rowIndex;
                        errorObj['key'] = apiResult.key;
                        errorObj['message'] = apiResult.message;

                        // errorLogs.push(errorObj);

                        let foundIndex = errorLogs.findIndex(obj => obj.row == rowIndex);
                        if (foundIndex != -1) {
                            errorLogs[foundIndex] = errorObj;
                        }
                        else {
                            errorLogs.push(errorObj);
                        }

                        // currentErrorObject['rowIndex'] = rowIndex + 1;
                        // currentErrorObject['key'] = apiResult.key;
                        // currentErrorObject['message'] = apiResult.message;
                        let postResourceDetailsArray = this.state.postResourceDetailsArray;
                        let rowItem = postResourceDetailsArray[rowIndex];
                        rowItem['status'] = 'failed';
                        postResourceDetailsArray[rowIndex] = rowItem;
                        if (isRetry != "true") {
                            importProgressSummary['failed'] += 1;
                            importProgressSummary['pending'] -= 1;
                        }

                        importPointer['status'] = 'failed';

                        postResourceDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;

                        this.setState({
                            postResourceDetailsArray: postResourceDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentErrorObject: errorLogs[0],
                            currentPointer: 0,
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportVerifyResourceDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                }
                else {
                    let postResourceDetailsArray = this.state.postResourceDetailsArray;
                    importProgressSummary['failed'] += 1;
                    importPointer['status'] = 'failed';
                    postResourceDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                    importPointer['loading'] = false;

                    this.setState({
                        postResourceDetailsArray: postResourceDetailsArray,
                        importProgressSummary: importProgressSummary,
                        importPointer: importPointer,
                        currentPointer: 0,
                    }, () => {

                        if (isRetry != "true") {

                            this.apiCallToImportVerifyResourceDetails(rowIndex + 1, importProgressSummary, isRetry);
                        }
                    })

                }
            }

        } else {
            this.setState({
                loadingImportProcess: false
            })
        }
    }


    // API CALL TO IMPORT Resource
    apiCallToImportResourceDetails = async (rowIndex = 0, importProgressSummary = { completed: 0, failed: 0, total: 0, pending: 0 }, isRetry = "") => {

        if (rowIndex < this.state.postResourceDetailsArray.length) {
            let ResourceData = this.state.postResourceDetailsArray[rowIndex];

            let resourceDetailsObj = {};
            let publisherItemValue = [];
            let publisherData = [];
            let categoryItemValues = [];
            let categoryData = [];
            let departmentItemValues = [];
            let departmentData = [];
            let accessionSeriesItemValue = [];
            let locationItemValue = [];
            let invoiceNoItemValue = [];


            // publisher data id
            if (typeof ResourceData['Publisher*'] === 'string') {
                // If it's a string, split it by commas
                publisherData = ResourceData['Publisher*'].split(',').map(val => val.trim());
            } else {
                publisherData = ResourceData['Publisher*']
            }

            let publisherValue = Object.values(this.state.publisherDataList).filter(item => publisherData.includes(item.name));

            publisherItemValue = JSON.stringify(publisherValue.map(item => item.value));

            // category data id
            if (typeof ResourceData['Resource Category*'] === 'string') {
                // If it's a string, split it by commas
                categoryData = ResourceData['Resource Category*'].split(',').map(val => val.trim());
            } else {
                categoryData = ResourceData['Resource Category*']
            }

            let filteredCategoryData = []
            Object.values(this.state.GetResourceCategoryList).forEach(cat => {
                // Match top-level category
                if (categoryData.includes(cat.name)) {
                    filteredCategoryData.push({ value: cat.value, label: cat.name });
                }

                // Match sub-categories
                cat.subCategories?.forEach(sub => {
                    if (categoryData.includes(sub.subCategoryName)) {
                        filteredCategoryData.push({ value: sub.subCategoryId, label: sub.subCategoryName });
                    }
                });
            });

            categoryItemValues = JSON.stringify(filteredCategoryData.map(item => item.value));

            // department/stream data id
            if (typeof ResourceData['Department'] === 'string') {
                // If it's a string, split it by commas
                departmentData = ResourceData['Department'].split(',').map(val => val.trim());
            } else {
                departmentData = ResourceData['Department']
            }

            // let departmentValue = departmentData.filter(item => ResourceData['Department'].includes(item.name));
            let filteredDepartmentData = []
            Object.values(this.state.GetStreamList).forEach(cat => {
                // Match top-level category
                if (departmentData.includes(cat.name)) {
                    filteredDepartmentData.push({ value: cat.sid, label: cat.name });
                }
            });

            departmentItemValues = JSON.stringify(filteredDepartmentData.map(item => item.value));

            // location data id
            Object.values(this.state.GetLocationList).forEach(item => {
                // Match top-level category
                if (ResourceData['Location'].includes(item.name)) {
                    locationItemValue.push({ value: item.value, label: item.name });
                }
                
                item.sublocations?.forEach(sub => {
                    if (sub.sublocationName.trim() === ResourceData['Location']) {
                        locationItemValue.push({
                            value: sub.sublocationId,
                            label: sub.sublocationName
                        });
                    }
                });
            });

            // accession series id
            accessionSeriesItemValue = Object.values(this.state.accessionSeriesList)
                .filter(item => item.label === ResourceData['Accession Series*'])
                .map(({ value, label }) => ({ value, label }));

            // invoice no id
            invoiceNoItemValue = Object.entries(this.state.GetInvoiceDataList)
                .filter(([key, item]) => String(item.billno) === String(ResourceData['Invoice/Bill No']))
                .map(([key, item]) => ({
                    value: item.value,
                    label: item.billno
                }));


            let accessionSeriesName = accessionSeriesItemValue.length > 0 ? accessionSeriesItemValue[0].value : "";
            let accessionNumber = ResourceData['Accession Number*'] ? ResourceData['Accession Number*'] : "";
            let FormattedAccessionDate = ResourceData['Accession Date'] ? ResourceData['Accession Date'] : "";
            let callNumber = ResourceData['Call Number'] ? ResourceData['Call Number'] : "";
            let titleName = ResourceData['Title*'] ? Base64.encode(ResourceData['Title*']) : "";
            let authorName = ResourceData['Author Name*'] ? Base64.encode(ResourceData['Author Name*']) : "";
            let volumeName = ResourceData['Resource Volume'] ? ResourceData['Resource Volume'] : "";
            let editionName = ResourceData['Resource Edition'] ? ResourceData['Resource Edition'] : "";
            let resourceLanguageName = ResourceData['Resource Language*'] ? ResourceData['Resource Language*'] : "";
            let NoOfPages = ResourceData['Number of Pages'] ? ResourceData['Number of Pages'] : "";
            let preliminaryPages = ResourceData['Number of Preliminary Pages'] ? ResourceData['Number of Preliminary Pages'] : "";
            let yearOfPublication = ResourceData['Year of Publication'] ? ResourceData['Year of Publication'] : "";
            let streamIdName = ResourceData['Department'] ? ResourceData['Department'] : "";
            let resourceTypeName = ResourceData['Resource Type*'] ? ResourceData['Resource Type*'] : "";
            let translatorName = ResourceData['Translator Name'] ? ResourceData['Translator Name'] : "";
            let isTranslated = ResourceData['Translated'] ? ResourceData['Translated'] : "Yes";
            let keywordName = ResourceData['Search Keyword'] ? ResourceData['Search Keyword'] : "";
            let locationName = locationItemValue.length > 0 ? locationItemValue[0].value : "";
            let isbnNumber = ResourceData['ISBN Number'] ? ResourceData['ISBN Number'] : "";
            let resourceConditionName = ResourceData['Resource Condition'] ? ResourceData['Resource Condition'] : "Good";
            let invoiceNumber = invoiceNoItemValue.length > 0 ? invoiceNoItemValue[0].value : "";
            let priceData = ResourceData['Price (In Rs)'] ? ResourceData['Price (In Rs)'] : (ResourceData['Price'] ? ResourceData['Price'] : "");
            let discountData = ResourceData['Discount (in %)'] ? ResourceData['Discount (in %)'] : "";
            let invoiceDate = invoiceNumber ? ResourceData['Invoice/ Bill Date'] : "";
            let netPrice = ResourceData['Net Price (In Rs)'] ? (ResourceData['Net Price (In Rs)']) : "";

            resourceDetailsObj = {
                "medium": "Physical",
                "eresource_path": "",
                "eresource_access": "",
                "accessionnumber": accessionNumber,
                "accession_date": FormattedAccessionDate,
                "callNumber": callNumber,
                "title": titleName,
                "author": authorName,
                "volume": volumeName,
                "edition": editionName,
                "resource_lang": resourceLanguageName,
                "number_of_pages": NoOfPages,
                "preliminarypages": preliminaryPages,
                "resourceCategory": categoryItemValues,
                "yearOfPublication": yearOfPublication,
                "resource_type": resourceTypeName,
                "translatorName": translatorName,
                "Translated": isTranslated,
                "keyword": keywordName,
                "isbn_number": isbnNumber,
                "resource_condition": resourceConditionName,
                "bill_date": invoiceDate,
                "price": priceData,
                "discount": discountData,
                "netprice": netPrice,
                "number_of_copies": 1,
                "specimen": "",
                "accessionseriesid": accessionSeriesName,
                "publisherid": publisherItemValue,
                "stream": departmentItemValues,
                "location": locationName,
                "invoiceno": invoiceNumber,
                "billNumber": ""
            }

            let requestData = {
                "iid": this.state.iidImportResource, //config.institute_id,
                "resourceDetailsObj": resourceDetailsObj,
                "facultyId": config.faculty_id,
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'ImportNewLibraryResources',
                requestData,
                "/api/library/instructor.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToImportResourceDetails(rowIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    if (apiResult.status == 'success') {
                        // toast.success(apiResult.message, {
                        //     position: "top-right",
                        //     autoClose: 2000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     progress: undefined,
                        // });
                        this.apiCallToImportResourceDetails(rowIndex + 1);
                        // this.setState({
                        //     successModal: true,
                        //     successModalType: 'success',
                        //     successMessage: apiResult.message
                        // }, () => {
                        //     this.apiCallToImportResourceDetails(rowIndex + 1);
                        // });
                    }
                    else {
                        toast.warn(apiResult.message, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        this.apiCallToImportResourceDetails(rowIndex + 1);
                        // this.setState({
                        //     successModal: true,
                        //     successModalType: 'warning',
                        //     successMessage: apiResult.message
                        // }, () => {
                        //     this.apiCallToImportResourceDetails(rowIndex + 1);
                        // });
                    }
                }
                else {
                    toast.error('Something went wrong while updating resource. Please try again later.', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToImportResourceDetails(rowIndex + 1);
                    // this.setState({
                    //     successModal: true,
                    //     successModalType: 'error',
                    //     successMessage: 'Something went wrong while updating resource. Please try again later.'
                    // }, () => {
                    //     this.apiCallToImportResourceDetails(rowIndex + 1);
                    // });
                }
            }

        } else {
            this.setState({
                loadingImportResourceProcess: false,
                isImportButtonDisabled: true
            })
            // common success message
            toast.success("Resource data added successfully.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    checkImportStatus = () => {
        return this.state.postResourceDetailsArray.some((item, index) => item.importStatus == 'success')
    }

    checkImportTabProgress = (index) => {
        if (index == 0) {
            return this.state.validations['isVerified']
        } else if (index == 1) {
            return this.checkImportStatus()
        }
    }

    render() {
        return (
            <>
                {/* <FontAwesomeIcon size='sm' style={{ color: '#0465AC', cursor: 'pointer' }} title="Click here to import" icon={["fa", "file-import"]} onClick={this.openImportResourceModal} /> */}


                {this.importResourceModal()}
                <div id="exportList"></div>
                <SuccessModal
                    successModal={this.state.successModal}
                    successModalType={this.state.successModalType}
                    successMessage={this.state.successMessage}
                    closeSuccessModal={this.closeSuccessModal}
                />

            </>
        )
    }
}

const ProgressBar = (props) => {
    const { bgcolor, completed, failed, pending, total } = props;

    let pendingProgressWidth = parseFloat(((pending / total) * 100).toFixed(2));
    let completedProgressWidth = parseFloat(((completed / total) * 100).toFixed(2));
    let failedProgressWidth = parseFloat(((failed / total) * 100).toFixed(2));


    const containerStyles = {
        // height: 15,
        width: '100%',
        backgroundColor: "#e0e0de",
        margin: '0.2em 0',
        display: 'flex',

    }

    const fillerStyles = {
        height: '100%',
        borderRadius: 'inherit',
        textAlign: 'right',
        transition: 'width 1s ease-in-out',
    }

    const labelStyles = {
        padding: 5,
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px'
    }
    const completedProgress = {
        width: `${completedProgressWidth}%`,
        backgroundColor: 'green'
    }


    const failedProgress = {
        width: `${failedProgressWidth}%`,
        backgroundColor: 'tomato'
    }

    const pendingProgress = {
        width: `${pendingProgressWidth}%`,
        backgroundColor: 'orange'
    }
    return (
        <div style={containerStyles}>
            {
                total > 0 && (<>
                    <div style={{ ...fillerStyles, ...completedProgress }}>
                        <span style={labelStyles}>{`${completedProgressWidth}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...failedProgress }}>
                        <span style={labelStyles}>{`${failedProgressWidth}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...pendingProgress }}>
                        <span style={labelStyles}>{`${pendingProgressWidth}%`}</span>
                    </div>
                </>)
            }

        </div>
    );
};


const mapStateToProps = store => {
    return {
        // VARIABLES TO GET admin DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray },
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }
    };
};

export default connect(mapStateToProps)(ImportResource);
